import { apiClient } from './api';
import {
  AbstractThinkingRequest,
  AbstractThinkingResponse
} from '../models/abstractThinker';

export class AbstractThinkerService {
  static async startThinking(request: AbstractThinkingRequest): Promise<AbstractThinkingResponse> {
    const response = await apiClient.post('/api/thinker/abstract/abstract-thinking/start', request);
    return response.data;
  }
}

export default AbstractThinkerService;